import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'

export default function useAggregateVendors () {
  const reduxVendors = useSelector((state) => state.vendors || [])
  const [fetchedVendors, setFetchedVendors] = useState(null)
  const hasFetched = useRef(false)

  const fetchVendors = useCallback(() => {
    axios.get('/api/company/getVendors')
      .then((res) => {
        const vendors = Array.isArray(res.data) ? res.data : (res.data.vendors || [])
        if (vendors.length > 0) setFetchedVendors(vendors)
      })
      .catch((err) => console.error('[useAggregateVendors] fetch error:', err))
  }, [])

  useEffect(() => {
    if (reduxVendors.length === 0 && !hasFetched.current) {
      hasFetched.current = true
      fetchVendors()
    }
  }, [reduxVendors.length, fetchVendors])

  const allVendors = (fetchedVendors && fetchedVendors.length > 0) ? fetchedVendors : reduxVendors

  const suppliers = useMemo(() =>
    allVendors.filter(
      (v) => Array.isArray(v.capabilities) && v.capabilities.some(c => c.type === 'aggregate_rock' && c.isActive)
    ),
  [allVendors])

  return { allVendors, suppliers, refetch: fetchVendors }
}
